/** @format */
// eslint-disable-next-line check-file/filename-naming-convention -- Legacy code: do not use as an example.
import { css } from 'styled-components';

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = css`
    display: flex;
    flex-direction: column;
    min-height: 0;

    .cancel {
        position: absolute;
        top: var(--layout-spacing-24);
        right: var(--layout-spacing-24);
        z-index: 1;

        &:not(:hover) {
            background: var(--colors-surface-primary);
        }
    }

    .header {
        position: relative;
        padding: var(--layout-spacing-24) var(--layout-spacing-24) 0;

        h4 {
            margin: 0 var(--layout-spacing-32) var(--layout-spacing-8) 0;
        }

        .selected-count {
            font-size: 1.2rem;
        }

        .clear {
            position: absolute;
            bottom: 2px;
            right: var(--layout-spacing-24);
        }
    }

    .footer {
        border-top: 1px solid var(--colors-border-primary);
        padding: var(--layout-spacing-12);
        display: flex;
        justify-content: stretch;

        > button {
            flex: 1;

            &:first-of-type {
                margin-right: var(--layout-spacing-4);
            }

            &:last-of-type {
                margin-left: var(--layout-spacing-4);
            }
        }
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

export const styles = () => css`
    ${baseStyles}
`;
